//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { PermisionsFolderService } from 'src/app/Services/Global/Permissions/permisions-folder.service';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';


//-================ IMPORTS FOR CONSTANTS ================-\\

//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Filter_Check_Annexe } from 'src/app/Interfaces/Libraries/Library-FIN-int/Filter_Check_Annexe.interface';
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Annexe_VH } from 'src/app/Interfaces/Libraries/Library-FIN-int/Annexe_VH.interface';
import { Download_Log_FIN } from 'src/app/Constants/Backlog/FIN/Download_Log_FIN';
import { Permission, Permissions } from 'src/app/Constants/Admin/Permissions';
import { Permission_Folder_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Permissions/Permission_FIN.interface';
import { permissionSystemFolderFIN, PermissionSystemFolderFINType, tpermissionFolderFIN } from 'src/app/types/FIN/permissionFolderFIN.type';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';


@Component({
    selector: 'app-history-aannexe-fin',
    templateUrl: './history-aannexe-fin.component.html',
    styleUrls: ['./history-aannexe-fin.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/VersionHAnnexeGlobal.scss'],
    standalone: false
})
export class HistoryAAnnexeFINComponent implements OnInit {


  //+================== VARIABLES FOR HEADERS FM ==================+\\
  public HeadersVH_Annexe: Headers_CCP[] = [
    { ID: 1, Name: 'Descargar', Position: 1, Visible: true, Key_Header: 'DOWNA' },
    { ID: 1, Name: 'Nombre de anexo', Position: 1, Visible: true, Key_Header: 'NAMAN' },
    { ID: 1, Name: 'Anexo a documento', Position: 1, Visible: true, Key_Header: 'NAMEF' },
    { ID: 1, Name: 'Contribuidor', Position: 1, Visible: true, Key_Header: 'CONTR' },
    { ID: 1, Name: 'Fecha de carga', Position: 1, Visible: true, Key_Header: 'DACRE' },
    { ID: 1, Name: 'Estatus', Position: 1, Visible: true, Key_Header: 'STATU' },
  ];


  //+================== VARIABLES FOR SEARCH ==================+\\
  public Filter_VersionHA: string = '';


  //+================== VARIABLES FOR KEYS SNAPSHOTS ==================+\\
  private ID_Folder: number = 0;
  private ID_Annexe: number = 0;

  //+================== VARIABLE FOR ALL VERSION ANNEXE ==================+\\
  public List_Histrory_Version_Annexe: Annexe_VH[] = [];
  public SelectedList_Histrory_Version_Annexe: Annexe_VH[] = [];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLE PERMISION ==================+\\
  private Permission_FMH: Permission_Folder_FIN = {
    ID: 0,
    Permission: [],
    Folder: { ID: 0, Name: '', ID_Folder_Top: 0, status: 0, Directory: false, Inheritance: 0, InheritanceGA: 0, Optional_Approvers: 0 },
    Users_Groups_For_Role:
    {
      G_Approvers_1: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
      G_Approvers_2: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
      G_Approvers_3: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
      G_Approvers_4: { Users: [], gApproverFolderFIN: { ID_F: 0, ID_G: 0, ID_RG: 0, Required_RG: true } },
    }
  };
  public PermissionFIN: PermissionSystemFolderFINType = permissionSystemFolderFIN;

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;


  //+================== VARIABLES FOR CREDENTIALS USER ==================+\\
  private ID_User_BD: number = 0;

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_Annexe = {
    Status: [],
    Contributor_Name: [],
  };

  //-========================= SERVICES =========================-\\
  private router = inject(Router);
  public UserService = inject(UserDataService);
  private Service_FIN = inject(LibraryFINService);
  private activatedRouter = inject(ActivatedRoute);
  private PermissionFolder = inject(PermisionsFolderService);

  constructor() {
    this.ID_Folder = this.activatedRouter.snapshot.params['idF'];
    this.ID_Annexe = this.activatedRouter.snapshot.params['idA'];
    this.ID_User_BD = Number(localStorage.getItem('ID_U_DB'));
  }

  ngOnInit(): void {
    this.Load_Component_VH()
  }


  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_VH(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const Permisions_Level: Permission_Folder_FIN = await this.PermissionFolder.GetPermissionsInFolderFIN(this.ID_User_BD, this.ID_Folder);

      this.Permission_FMH = Permisions_Level;

      const ResVersionHistory: Response_FIN = await firstValueFrom(this.Service_FIN.Get_VersionH_Annexe_FIN({ ID_Annexe: this.ID_Annexe }));

      if (ResVersionHistory.success) {
        this.List_Histrory_Version_Annexe = ResVersionHistory.operation;

        this.Generate_Filters();
      }

      Loader.classList.remove('active');

    } catch (e) {

      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar el historial de versiones del anexo, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
    }
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\





  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================ FUNCTION TO GENERATE FILTER ================-\\
  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Status: [],
      Contributor_Name: [],
    };

    for (const Annexe of this.List_Histrory_Version_Annexe) {

      Annexe.Upload_Date = moment(Annexe.Upload_Date).utc().toDate();

      if (!this.Filter_Global_Check.Status.includes(Annexe.Status) && Annexe.Status !== null) {
        this.Filter_Global_Check.Status.push(Annexe.Status);
      }

      if (!this.Filter_Global_Check.Contributor_Name.includes(Annexe.Contributor_Name) && Annexe.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push(Annexe.Contributor_Name);
      }
    }
  }

  //-================ FUNCTION FOR DATE FORMAT ================-\\
  public Date_Format(Upload_Date: Date): string {
    return moment(Upload_Date).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================ FUNCTION RETURN STRING STATUS ================-\\
  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Carga nueva';
      case 2: return 'Anexo actualizado';
      case 3: return 'Anexo sin actualización';
      case 4: return 'Eliminado por actualización';
      case 5: return 'Eliminado';
      default: return '';
    }
  }

  //-================ FUNCTION FOR ROLE USER ================-\\
  public UserRoleIn(Permissions: tpermissionFolderFIN[]): boolean {


    for (const Role of this.Permission_FMH.Permission) {
      const PermissionsFound = Permissions.find((p: tpermissionFolderFIN) => {
        return (p.toUpperCase() === Role.toUpperCase());
      })
      if (PermissionsFound) {
        return true;
      }

    }

    return false;

  }

  //-============== FUNCTION TO GET ANNEX DOWNLOAD URL ==============-\\
  public async Download_Annexe(Annexe: Annexe_VH, Position: number): Promise<void> {

    try {

      const ResGetURLFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Get_URL_Download_Annexe_FIN({ ID_Annexe: Annexe.ID, Type_D: Download_Log_FIN.D_ANN_VERS_H_AN }));

      if (ResGetURLFIN.success) {

        const URL = ResGetURLFIN.operation.URL_Annexe;

        const IsDownload = this.Download_Annexe_FIN(URL, Annexe.Name, Position);

        if (!IsDownload) throw new Error('No file Download');
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar el anexo del Proceso, informa a tu supervisor!'
      })
    }

  }

  //-============== FUNCTION TO GET ANNEX DOWNLOAD URL ==============-\\
  private async Download_Annexe_FIN(URL: string, File_Name: string, Position: number): Promise<boolean> {


    return new Promise((resolve) => {

      const Btn_Download = document.getElementById(`Btn-Download${Position}`) as HTMLDivElement;
      const Progress_Bar_Task = document.getElementById(`Progress-Bar-Task${Position}`) as HTMLSpanElement;


      const Text_Btn = document.getElementById(`Text-Btn${Position}`) as HTMLElement;
      const Icon_Btn = document.getElementById(`Icon-Btn${Position}`) as HTMLElement;


      Btn_Download.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Task.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          Progress_Bar_Task.style.width = '0%';
          Btn_Download.classList.remove('active');

          Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-check-double');
          Text_Btn.innerHTML = 'Completada';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Anexo descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el anexo del Proceso, informe a su supervisor!'
          })

          Btn_Download.classList.remove('active');
          Progress_Bar_Task.style.width = '0%';
          Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-xmark');
          Text_Btn.innerHTML = 'Error';

          resolve(false);
        }

      })
    })

  }

  //-================ FUNCTION FOR SEE ANNEXE ================-\\
  public See_Flow_Annexe(): void {
    this.router.navigate(['Dashboard/FIN/VersionHAnne/', this.ID_Annexe]);
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\

}
